import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-capture-authorized-payment',
  templateUrl: './capture-authorized-payment.component.html',
  styleUrls: ['./capture-authorized-payment.component.scss']
})
export class CaptureAuthorizedPaymentComponent implements OnInit {

  @Input() securityDepositInfo;
  @Input() partner;

  constructor(
    public modal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  valid(){
    return this.securityDepositInfo.capturedAmount > 0 && this.securityDepositInfo.capturedAmount <= this.securityDepositInfo.authorizationAmount;
  }

  capturePaymentAmount(){
    this.modal.close(this.securityDepositInfo);
  }

}
